module.exports = __webpack_public_path__ + "static/media/wallet.f7c4f0ca.svg";